import {useRef} from "react";
import {MultiSelect} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {
    DataStatusToStatus,
    Status,
    StatusToDataStatus,
    type DataStatus,
} from "../types";
import {getStatusFilterItems} from "./statusNames";
import styles from "./checklist.module.css";

type StatusFilterProps = {
    selected: (Status | string)[];
    onToggle: (status: Status | string) => void;
};

export const StatusFilter = ({selected, onToggle}: StatusFilterProps) => {
    const {t} = useTranslation();
    const statusItems = getStatusFilterItems();
    const prevRef = useRef<string[]>([]);

    // Convert Status enum values to DataStatus strings for display
    const value = selected.map((s) => {
        if (typeof s === "string") return s;
        return StatusToDataStatus[s as Status] ?? s;
    });
    prevRef.current = value;

    const handleChange = (newValue: string[]) => {
        const prev = new Set(prevRef.current);
        const next = new Set(newValue);

        // Find added item
        for (const v of next) {
            if (!prev.has(v)) {
                const mapped =
                    DataStatusToStatus[v as DataStatus];
                if (mapped !== undefined) onToggle(mapped);
                return;
            }
        }
        // Find removed item
        for (const v of prev) {
            if (!next.has(v)) {
                const mapped =
                    DataStatusToStatus[v as DataStatus];
                if (mapped !== undefined) onToggle(mapped);
                return;
            }
        }
    };

    return (
        <MultiSelect
            data={statusItems}
            value={value}
            onChange={handleChange}
            placeholder={value.length === 0 ? t("Word.Status") : undefined}
            aria-label={t("Word.Status")}
            hidePickedOptions
            nothingFoundMessage={t("Info.ListIsEmpty", {
                defaultValue: "The list is empty",
            })}
            size="sm"
            classNames={{input: styles.filterInput}}
            style={{minWidth: "10rem", maxWidth: "16rem"}}
        />
    );
};
